import type { JSX } from 'preact';
import type { Status } from '../types';

const STYLES: Record<NonNullable<Status>, JSX.CSSProperties> = {
  yes: {
    background: 'var(--accent-mint-bg)',
    color: 'var(--accent-mint-ink)',
    fontWeight: 600,
  },
  maybe: {
    background: 'var(--accent-peach-bg)',
    color: 'var(--accent-peach-ink)',
    fontWeight: 600,
  },
  no: {
    background: 'var(--surface-card)',
    color: 'var(--muted)',
    fontWeight: 600,
  },
};

const LABELS: Record<NonNullable<Status>, string> = { yes: 'Yes', maybe: 'Maybe', no: 'No' };

const PILL_BASE: JSX.CSSProperties = {
  padding: '4px 10px',
  borderRadius: 'var(--radius-pill)',
  fontSize: 11,
  letterSpacing: '0.3px',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
};

export function StatusTag(props: { status: Status | null }) {
  if (!props.status) return null;
  return (
    <span style={{ ...PILL_BASE, ...STYLES[props.status] }}>
      {LABELS[props.status]}
    </span>
  );
}
